import styled from 'styled-components';
import {
  Alert as MaterialAlert,
  AlertProps as MaterialAlertProps,
  Typography,
} from '@mui/material';
import { ReactComponent as ErrorIcon } from '../../assets/alert-error.svg';
import { ReactComponent as InfoIcon } from '../../assets/alert-info.svg';
import { ReactComponent as SuccessIcon } from '../../assets/alert-success.svg';
import { ReactComponent as WarningIcon } from '../../assets/alert-warning.svg';

export const alertIcons = {
  success: <SuccessIcon />,
  warning: <WarningIcon />,
  error: <ErrorIcon />,
  info: <InfoIcon />,
};

const AlertStyled = styled(MaterialAlert)`
  white-space: pre-wrap;

  & .MuiAlert-message {
    width: 100%;
    min-width: 0;
    overflow: hidden;
  }

  & .MuiAlert-icon {
    margin-top: auto;
    margin-bottom: auto;
    font-size: 32px;
  }

  &.MuiAlert-standardInfo {
    background-color: ${({ theme }) => theme.palette.common.lightBlue};
    path {
      fill: ${({ theme }) => theme.palette.common.blue7};
    }
  }
`;

const AlertTitle = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  margin-bottom: 4px;
`;

interface AlertProps extends MaterialAlertProps {
  title?: string;
}

const Alert = ({ title, children, ...props }: AlertProps) => (
  <AlertStyled
    {...props}
    iconMapping={alertIcons}
    style={{
      width: '100%',
      minWidth: 'unset',
      ...(props.style || {}),
    }}
  >
    {title && <AlertTitle>{title}</AlertTitle>}
    {children}
  </AlertStyled>
);

export default Alert;
